import { render, staticRenderFns } from "./MobilePhone.vue?vue&type=template&id=741e4cbe&scoped=true&"
import script from "./MobilePhone.vue?vue&type=script&lang=js&"
export * from "./MobilePhone.vue?vue&type=script&lang=js&"
import style0 from "./MobilePhone.vue?vue&type=style&index=0&id=741e4cbe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741e4cbe",
  null
  
)

export default component.exports